/* tslint:disable */
/* eslint-disable */
export enum YesNoValue {
  YES = 'YES',
  NO = 'NO'
}
